import http from "../common/http-common";
import { IRegister } from "../../interfaces/IRegister";
import DTOUsuariosShort from "../../DTO/DTOUsuariosShort";
import DTOClonarUsuario from "../../DTO/DTOClonarUsuario";
import DTOUsuario from "../../DTO/DTOUsuario";
import { IUsuario } from "../../interfaces/IUsuario";
import Supervisor from "../../Componest/Catalogos/CatEmpleados/DTO/Supervisor";


class usuariosService {
  constructor() {
  }
  validate() {
    return http.get<null>("/Auth/validate");
  }
  getAllUsuarios() {
    return http.get<IRegister[]>("/Usuarios/getAllUsuarios");
  }
  getAllSupervisor() {
    return http.get<Supervisor[]>("/Usuarios/getAllSupervisor");
  }
  upsSupervisor(supervisor: Supervisor) {
  return http.post<Supervisor>('/Usuarios/UpsSupervisor', supervisor);
  }

  

deleteSupervisor(numEmpleado: string) {
  return http.delete(`/Usuarios/DeleteSupervisor/${numEmpleado}`);
}

limpiarSubordinados(idSupervisor : number) 
{
  return http.put(`/Usuarios/limpiarSubordinados/${idSupervisor}`); 

}

eliminarUsuariosCompartidos(idSupervisor: number) {
  return http.delete(`/Usuarios/EliminarUsuariosCompartidos/${idSupervisor}`);
}


eliminarUsuarioCompartidoIndividual(numEmpleado: string, idSupervisor: number) {
  return http.delete(`/Usuarios/EliminarUsuarioCompartidoIndividual`, {
    params: {
      numEmpleado,
      idSupervisor
    }
  });
}


getAllUsuarioPorSupervisor(idSupervisor: string) {
  return http.get(`/Usuarios/getAllUsuarioPorSupervisor`, {
    params: { IdSupervisor: idSupervisor }
  });
}

getAllUsuarioPorSupervisorCompartido(idSupervisor: string) {
  return http.get(`/Usuarios/getAllUsuarioPorSupervisorCompartido`, {
    params: { IdSupervisor: idSupervisor }
  });
}





moverUsuariosSupervisor(idSupervisorActual: number, idSupervisorNuevo: number) {
  return http.post(`/Usuarios/MoverUsuariosSupervisor`, null, {
    params: {
      idSupervisorActual,
      idSupervisorNuevo,
    },
  });
}

compartirUsuariosConSupervisor(IdSupervisorCompartidor :number, idSupervisorReceptor: number) {
  return http.post(`/Usuarios/CompartirUsuariosConSupervisor`, null, {
    params: {
      IdSupervisorCompartidor,
      idSupervisorReceptor,
    },
  });
}



compartirUsuarioIndividual(numEmpleado: string, idSupervisorReceptor: number )
{
  return http.post(`/Usuarios/CompartirUsuarioIndividual`, null, {
    params: {
      numEmpleado,
      idSupervisorReceptor,
    },
  });
}




actualizarSubordinados(idSupervisor: number, nuevosSubordinados: string) {
  return http.post(`/Usuarios/ActualizarSubordinados?idSupervisor=${idSupervisor}&nuevosSubordinados=${nuevosSubordinados}`);


}


  getAllUsuariosShort() {
    return http.get<DTOUsuariosShort[]>("/Usuarios/getAllUsuariosShort");
  }
  create(data: IUsuario) {
    return http.post<[IRegister[]]>("/Usuarios/createUsuario", data);
  }
  
  clonarUsuario(data: DTOClonarUsuario) {
    return http.post<[DTOClonarUsuario[]]>("/Usuarios/clonarUsuario", data);
  }
  disableUser(id: number) {
    return http.put<boolean>(`/Usuarios/disableUser?id=${id}`);
  }

 /* get(id: string) {
    return http.get<ITutorialData>(`/tutorials/${id}`);
  }
  create(data: ILogin) {
    return http.post<[ItemMenuData[]]>("/Auth", data);
  }
  update(data: ITutorialData, id: any) {
    return http.put<any>(`/tutorials/${id}`, data);
  }
  delete(id: any) {
    return http.delete<any>(`/tutorials/${id}`);
  }
  deleteAll() {
    return http.delete<any>(`/tutorials`);
  }
  findByTitle(title: string) {
    return http.get<Array<ITutorialData>>(`/tutorials?title=${title}`);
  }*/
}
export default new usuariosService();